export const Svg_114 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={70}
    height={70}
    fill="none"
  >
    <path
      fill="url(#a)"
      d="M35.02 64.167c-4.022 0-7.802-.766-11.339-2.297-3.537-1.531-6.63-3.621-9.28-6.27-2.649-2.65-4.74-5.745-6.27-9.286-1.532-3.54-2.297-7.324-2.297-11.35s.765-7.81 2.297-11.35c1.53-3.541 3.621-6.624 6.27-9.249 2.65-2.625 5.745-4.703 9.286-6.234 3.54-1.532 7.324-2.297 11.35-2.297s7.81.765 11.35 2.297c3.54 1.53 6.624 3.61 9.249 6.234 2.625 2.625 4.703 5.712 6.234 9.26 1.532 3.55 2.297 7.334 2.297 11.356s-.766 7.801-2.297 11.339c-1.531 3.537-3.61 6.626-6.234 9.266-2.625 2.64-5.712 4.73-9.26 6.27-3.55 1.541-7.334 2.311-11.356 2.311ZM35 59.792c6.921 0 12.784-2.418 17.587-7.255C57.39 47.7 59.792 41.855 59.792 35v-.948c-.292 1.263-.958 2.32-1.998 3.171s-2.27 1.277-3.69 1.277h-5.833c-1.604 0-2.977-.572-4.12-1.714-1.142-1.142-1.713-2.516-1.713-4.12V29.75H30.77v-5.833c0-1.604.571-2.977 1.714-4.12 1.142-1.142 2.515-1.713 4.12-1.713h2.916V16.48c0-.778.328-1.75.985-2.917.656-1.167 1.397-1.872 2.224-2.115a27.41 27.41 0 0 0-3.745-.911A23.647 23.647 0 0 0 35 10.209c-6.854 0-12.7 2.402-17.536 7.205-4.837 4.803-7.255 10.665-7.255 17.587h10.937c3.209 0 5.955 1.142 8.24 3.427 2.285 2.284 3.427 5.03 3.427 8.24v2.916h-8.75v7.656A24.233 24.233 0 0 0 35 59.792Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={19.323}
        x2={47.032}
        y1={14.584}
        y2={59.428}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
    </defs>
  </svg>
)